import React from 'react'
import { FormattedMessage } from 'react-intl'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import commonFunctions from '../../utils/commonFunctions'
 
function HwModal(props) {
  const { 
    success,
    error,
    handleEditReceiver,
    setCheckedRxExpiration,
    checkedRxExpiration,
    checkedRxExpirationValid,
    checkedRxExpirationChange,
    submitted
  } = props;

  return (
    <div className="modal fade" id="hwModal" tabIndex="-1" aria-labelledby="hwModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
              <h5 className="modal-title"><FormattedMessage id="EDIT_RECEIVERS" /></h5>
            <button type="button" id="btn-close" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <form>
              <div className="receiverField row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="receiverExpiration" className="col-form-label"><FormattedMessage id="RECEIVER_EXPIRATION" /></label>
                  <DatePicker 
                  dateFormat="MM/dd/yyyy"   
                  className={`form-control ${submitted && !checkedRxExpirationValid ? "is-valid" : submitted && checkedRxExpirationValid ? "is-invalid" : ""}`}
                  selected={checkedRxExpiration}
                  id="receiverExpiration" 
                  onChange={date => checkedRxExpirationChange(date)} />
                  {submitted && checkedRxExpirationValid && 
                    commonFunctions.InvalidFeedbackString(checkedRxExpirationValid, "RECEIVER_EXPIRATION", "d-block")
                  }
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            {error ? (
              <p className="text-danger"><FormattedMessage id="ERROR" />{error}</p>
            ) : null}
            {success ? (
              <p className="text-success">{success}</p>
            ) : null}
            <button type="button" className="btn save-btn" onClick={handleEditReceiver}><FormattedMessage id="SAVE" /></button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HwModal